import React from 'react';
import DeviceCard from './DeviceCard';

const DeviceCardGroup = ({ devices = [], deviceType }) => (
  <div className="grid grid--fixed-259">
    {devices.map(device => (
      <div key={device.serialNumber} className="grid__item">
        <DeviceCard device={{ ...device, deviceType: device.deviceType || deviceType }} />
      </div>
    ))}
  </div>
);

export default DeviceCardGroup;
